<div class="extracted-notes-list">
  <!-- AI summary: read-only, never editable -->
  <div *ngIf="summary" class="extracted-notes-summary">
    <span class="extracted-note-category extracted-summary-label">
      {{ 'quotations_and_orders.ai_summary' | translate }}
      <ui-svg-icon svgIcon="ai-volta-icon" size="small"></ui-svg-icon>
    </span>
    <span class="extracted-summary-text">{{ summary }}</span>
  </div>

  <!-- Extracted notes: inline editable + soft-removable -->
  <div
    class="extracted-note-item"
    *ngFor="let note of workingNotes; trackBy: trackByIndex"
    [class.is-editing]="note.editing"
    [class.is-edited]="note.edited && !note.removed"
    [class.is-removed]="note.removed"
    [class.is-editable]="editable"
  >
    <div class="extracted-note-header">
      <span *ngIf="note.category" class="extracted-note-category">{{ note.category }}</span>
      <ui-svg-icon
        *ngIf="note.edited && !note.removed"
        class="extracted-note-edited-badge"
        svgIcon="edit"
        size="small"
        [matTooltip]="'quotations_and_orders.extracted_notes_editor.edited' | translate"
      ></ui-svg-icon>
    </div>

    <!-- Removed: struck-through, with a restore action -->
    <ng-container *ngIf="note.removed; else activeTpl">
      <span
        class="extracted-note-text removed"
        [matTooltip]="'quotations_and_orders.extracted_notes_editor.removed_hint' | translate"
        >{{ note.text }}</span
      >
      <div class="extracted-note-actions-row" *ngIf="editable">
        <button
          type="button"
          class="note-icon-btn restore"
          (click)="revert(note)"
          [matTooltip]="'quotations_and_orders.extracted_notes_editor.restore' | translate"
        >
          <ui-svg-icon svgIcon="undo" size="medium"></ui-svg-icon>
          <span class="note-icon-btn-label">{{ 'quotations_and_orders.extracted_notes_editor.restore' | translate }}</span>
        </button>
      </div>
    </ng-container>

    <ng-template #activeTpl>
      <!-- View mode: text only (click to edit) -->
      <ng-container *ngIf="!note.editing; else editTpl">
        <span
          class="extracted-note-text"
          [class.clickable]="editable"
          (click)="startEdit(note)"
          >{{ note.text }}</span
        >
      </ng-container>

      <!-- Edit mode: textarea + trash (left) / confirm (right) -->
      <ng-template #editTpl>
        <textarea
          appAutofocus
          class="extracted-note-textarea"
          [(ngModel)]="note.draft"
          (keydown.enter)="onEnter($event, note)"
          (keydown.escape)="cancelEdit(note)"
          (blur)="cancelEdit(note)"
          rows="2"
        ></textarea>
        <div class="extracted-note-actions-row spread">
          <button
            type="button"
            class="note-icon-btn discard"
            (mousedown)="$event.preventDefault()"
            (click)="discard(note)"
            [matTooltip]="'quotations_and_orders.extracted_notes_editor.discard' | translate"
          >
            <ui-svg-icon svgIcon="trash-cc" size="medium"></ui-svg-icon>
          </button>
          <button
            type="button"
            class="note-icon-btn confirm"
            (mousedown)="$event.preventDefault()"
            (click)="confirmEdit(note)"
            [matTooltip]="'common.save' | translate"
          >
            <ui-svg-icon svgIcon="check-cc" size="medium"></ui-svg-icon>
          </button>
        </div>
      </ng-template>
    </ng-template>
  </div>
</div>
